"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var react_native_1 = require("react-native");

var styled_components_1 = __importStar(require("styled-components"));

exports.LoadingIndicator = function (_a) {
  var size = _a.size,
      fullScreen = _a.fullScreen,
      theme = _a.theme;
  var main = theme.colors.main;
  return react_1.default.createElement(Container, {
    fullScreen: fullScreen
  }, react_1.default.createElement(react_native_1.ActivityIndicator, {
    size: size,
    color: main.jade
  }));
};

var Container = styled_components_1.default(function (_a) {
  var fullScreen = _a.fullScreen,
      rest = __rest(_a, ["fullScreen"]);

  return react_1.default.createElement(react_native_1.View, __assign({}, rest));
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    margin: 5px;\n    ", "\n"], ["\n    margin: 5px;\n    ", "\n"])), function (_a) {
  var fullScreen = _a.fullScreen;
  return fullScreen ? "\n        width: 100%;\n        height: 100%;\n        justify-content: center;\n        align-items: center;\n        " : '';
});
exports.default = styled_components_1.withTheme(exports.LoadingIndicator);
var templateObject_1;